import { createSlice } from '@reduxjs/toolkit';

const CalendarSlice = createSlice({
  name: 'date',
  initialState: {
    year: String(new Date().getFullYear()),
    month: String(new Date().getMonth() + 1).padStart(2, '0'),
    day: String(new Date().getDate()).padStart(2, '0'),
  },
  reducers: {
    getDate: (_, action) => {
      return action.payload;
    },
  },
});

export const { getDate } = CalendarSlice.actions;

export const dateReducer = CalendarSlice.reducer;
